export default "__VITE_ASSET__CmXdvxxi__"